import { image } from 'utils/image';
import formatMoney from 'utils/format-money';

type Label = {
  displayName: string
  icon: null | string
};

export type Product = {
  image?: {
    alt: string
    src: string
    width: number
    height: number
  }
  id: number
  clerk: boolean
  variantID: number
  available: boolean
  title: string
  url: string
  compareAtPrice: number
  price: number
  vendor: string
  type: string
  tags: string[]
  labels: Label[] | null
};

export const renderProductItem = (product:Product) => {
  let template = window.theme.templates.productItem;

  let labelList = '';
  let labels = '';

  if (product.labels) {
    for (let i = 0; i < product.labels.length; i += 1) {
      const { icon, displayName } = product.labels[i];
      labels += `
        <li class="product-item__label--label">
          ${
  icon && icon !== ''
    ? (`<img
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          data-src="https://panzerglass.cloud4.structpim.com/umbraco/api/media/getmedia?id=${icon}&width=50&height=50"
          alt="${displayName}"
          class="product-item__label--label--icon lazyload"
        >`
    )
    : ''
}
          <p class="product-item__label--label--title">
            ${displayName}
          </p>
        </li>
      `;
    }
    labelList += `
      <ul class="product-item__label--list">
        ${labels}
      </ul>
    `;
  }

  if (product.price < product.compareAtPrice) {
    const discount = Math.floor(
      ((product.compareAtPrice - product.price) / product.compareAtPrice) * 100,
    );
    labelList += `
      <span class="product-item__label--discount">
        ${discount}%
      </span>
    `;
  }

  template = template.replace('[%product_labels%]', labelList);

  if (product.image) {
    template = template.replace('[%product_image%]', image(product.image, 1));
  } else {
    template = template.replace('[%product_image%]', '<div class="aspect-ratio aspect-ratio--1/1 bg-neutral-200"></div>');
  }

  if (!product.available) {
    template = template.replace(
      '[%product_status%]',
      `<div class="product-item__status--list">
        <p class="product-item__status--label text-semantic-danger">
          ${window.theme.strings.product.inventory.outOfStock}
        </p>
      </div>`,
    );
  } else {
    template = template.replace('[%product_status%]', '');
  }

  template = template.replace('[%product_title%]', product.title);
  template = template.replace('[%aria_label%]', product.title.replace('"', "'"));
  template = template.replace('[%product_price%]', `${formatMoney(product.price)}`);
  template = template.replaceAll('[%product_url%]', product.url);

  template = template.replace('[%product_vendorType%]', () => `${product.vendor} - ${product.type}`);

  template = template.replace('[%product_compareAtPrice%]', () => {
    if (product.price < product.compareAtPrice) {
      return `
      <p class="absolute top-0 left-0 whitespace-nowrap -translate-y-full text-neutral-500 line-through text-sm font-medium">
        ${formatMoney(product.compareAtPrice)}
      </p>
      `;
    }
    return '';
  });

  if (product.available) {
    template = template.replace('[%button_disabled%]', '');
    template = template.replace('[%submit_button_text%]', window.theme.strings.product.form.addToCart);
  } else {
    template = template.replace('[%button_disabled%]', ' disabled ');
    template = template.replace('[%submit_button_text%]', window.theme.strings.product.form.soldOut);
  }

  // Tags can include "' so we have to remove those so the JSON doesn't break on the site
  const productTags = product.tags.map((tag) => tag.replace(/['"]/g, ''));

  const variantObject = {
    id: product.variantID,
    quantity: 1,
    compare_at_price: product.compareAtPrice,
    tags: productTags,
  };

  if (!product.clerk) {
    template = template.replace('[%data_variant%]', `data-variant='${JSON.stringify(variantObject)}'`);
  } else {
    template = template.replace('[%data_variant%]', `data-clerk-product-id="${product.id}" data-variant='${JSON.stringify(variantObject)}'`);
  }

  return template;
};

export default {
  renderProductItem,
};
